import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, List, Avatar } from 'antd';
import withAuthenticator from 'HOCs/withAuthenticator';
import { BiGroup, BiChevronRight } from 'react-icons/bi';
import { query } from 'helpers/QueryHelper';

import { useQuery } from 'react-query';

const randomColors = ['#007AFF', '#2ECE76', '#FFAB1A', '#FF5C39', '#6474FC'];

const Block = ({ imageName, text, score, color }) => {
  return (
    <Row>
      <Col flex='40px' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <img src={`/assets/sachso/images/skills/${imageName}.png`} alt={text} style={{ height: 30 }} />
      </Col>
      <Col flex={1} className='pl-2'>
        <div style={{ fontWeight: 600, fontSize: 12, color }}>{text}</div>
        <div style={{ fontWeight: 600, fontSize: 12, color }}>{score}</div>
      </Col>
    </Row>
  );
};

export default withAuthenticator(({ loggedInUser }) => {
  return (
    <div>
      <Row gutter={[16, 24]}>
        <Col span={12}>
          <Block imageName='Listening' text='Nghe' score='0' color='#6474FC' />
        </Col>
        <Col span={12}>
          <Block imageName='Speaking' text='Nói' score='0' coloe='#FFAB1A' />
        </Col>
        <Col span={12}>
          <Block imageName='Reading' text='Đọc' score='0' color='#007AFF' />
        </Col>
        <Col span={12}>
          <Block imageName='Writting' text='Viết' score='0' color='#2ECE76' />
        </Col>
      </Row>
    </div>
  );
});
